module.exports = __webpack_public_path__ + "static/media/ic-lodge.4e51d64a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-lodge.svg
// module id = 639
// module chunks = 14